import { LoadingButton } from "@mui/lab";
import styles from "./AccountClosureSettlement.module.scss";
import React, { useEffect, useState } from "react";
import keyboardicon from "../../../Components/assets/Images/panicongrey.svg";
import acradio from "../../../Components/assets/Images/acradio.svg";
import inforedicon from "../../../Components/assets/Images/inforedicon.svg";
import payoutsuccessicon from "../../../Components/assets/Images/payoutsuccessicon.svg";
import infogreyiconnew from "../../../Components/assets/Images/infogreyiconnew.svg";
import otpIcon from "../../../Components/assets/Images/otpIcon.svg";
import { Box, InputAdornment, Modal, TextField } from "@mui/material";
import {
  InitiateFundTransferAccountClosureAPICall,
  ResendOTPAccoutClosureAPICall,
  sendOTPAccoutClosureAPICall,
  stageDetailsAPICall,
  SubmitSettlementAccountClosureAPICall,
  verifyOTPAccoutClosureAPICall,
} from "../APICallsAccountClosure";
import { getCookie } from "../cookies";
import { useNavigate } from "react-router-dom";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import SnackBar from "../../../Components/SnackBars/SnackBar";
import ErrorSnackBar from "../../../Components/SnackBars/ErrorSnackBar";
import SucessSnackBar from "../../../Components/SnackBars/SucesssnackBar";
import { confirmAlert } from "react-confirm-alert";

const successModalStyles = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  width: "100%",
  height: "100vh",
  transform: "translate(-50%, -50%)",
  margin: "auto",
  borderRadius: "10px",
  boxShadow: 24,
  padding: "40px 30px",
  outline: "none",
  display: "flex",
};

const AccountClosureSettlement = () => {
  const navigate = useNavigate();
  const [accountClosureReason, setaccountClosureReason] = useState("");
  const [address, setAddress] = useState("");
  const [settlementType, setSettlementType] = useState(1);
  const [holdingsType, setHoldingsType] = useState(1);
  const [clientdpid, setclientdpid] = useState("");
  const [targetdpid, settargetdpid] = useState("");
  const [showModal, setshowModal] = useState(false);
  const [showModalPaisa, setshowModalPaisa] = useState(false);
  const [showOTPModal, setshowOTPModal] = useState(false);
  const [amount, setamount] = useState(0);
  const [holdings, setHoldings] = useState([]);
  const [mobileotp, setMobileOtp] = useState("");
  const [fundTransfer, setFundtransfer] = useState(false);
  const [mobileNumber, setMobileNumber] = useState("");
  const [errorMessage, seterrorMessage] = useState("");
  const [rejectMessage, setRejectMessage] = useState("");
  const [nextStage, setNextStage] = useState("");
  const [successMessage, setsuccessMessage] = useState("");
  const [countdown, setCountdown] = useState<any>(30);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [timerId, setTimerId] = useState<any>(null);

  const userid: any = getCookie("userId");

  useEffect(() => {
    window.scrollTo(0, 0);
    StageDetails();
  }, []);

  useEffect(() => {
    setIsButtonDisabled(true);
    setCountdown(30);
  }, []);

  useEffect(() => {
    if (countdown <= 0 && timerId !== null) {
      setIsButtonDisabled(false);

      clearInterval(timerId);
      setTimerId(null);
    }
  }, [countdown]);

  const StageDetails = () => {
    let obj: any = {
      stage: "account_settlement",
      request_id: sessionStorage.getItem("acrequestID"),
    };

    stageDetailsAPICall(obj)
      .then((response: any) => {
        setamount(response.data.data.data.margin);
        setMobileNumber(response.data.data.data.mobile_no);
        setFundtransfer(response.data.data.data.is_fund_transfer_initiated);

        if (response.data.data.ErrMessage) {
          setRejectMessage(response.data.data.ErrMessage);
        }

        if (response.data.data.data.margin > 1) {
          if (response.data.data.data.is_fund_transfer_initiated === true) {
            setshowModal(false);
          } else {
            setshowModal(true);
          }
        }
        if (
          response.data.data.data.margin > 0 &&
          response.data.data.data.margin < 1
        ) {
          if (response.data.data.data.is_fund_transfer_initiated === true) {
            setshowModalPaisa(false);
          } else {
            setshowModalPaisa(true);
          }
        }
        if (response.data.data.data?.account_closure_reason) {
          setaccountClosureReason(
            response.data.data.data?.account_closure_reason
          );
        }
        if (response.data.data.data?.address) {
          setAddress(response.data.data.data?.address);
        }
        setHoldings(response.data.data.data.holding);
        if (response.data.data.data.holding?.length === 0) {
          setHoldingsType(0);
        }
        if (response.data.data.data.is_holding_transfer_opted) {
          setHoldingsType(2);
        }
        if (response.data.data.data.holding_details.dp_id) {
          settargetdpid(response.data.data.data.holding_details.dp_id);
        }
        if (response.data.data.data.holding_details.client_code) {
          setclientdpid(response.data.data.data.holding_details.client_code);
        }
      })
      .catch((error: any) => {
        //  console.log("error", error);
      });
  };

  const handleSettlement = () => {
    if (holdingsType === 1) {
      window.location.href = "https://app.firstock.in/login";
    } else {
      if (accountClosureReason?.length < 6) {
        confirmAlert({
          title: "",
          message: "Account Closure reason should be minimum of 6 characters.",
          buttons: [
            {
              label: "Ok",
              onClick: () => {},
            },
          ],
        });
      } else {
        SubmitSettlement();
      }
    }
  };

  const SubmitOTP = () => {
    let obj: any = {
      request_id: sessionStorage.getItem("acrequestID"),
      otp: mobileotp,
    };

    verifyOTPAccoutClosureAPICall(obj)
      .then((response: any) => {
        navigate(`/account_closure/${nextStage}`);
      })
      .catch((error: any) => {
        seterrorMessage(
          error.message.includes("Network")
            ? "Error occured, Please try again"
            : error.response.data.message
        );
        setTimeout(() => {
          seterrorMessage("");
        }, 5000);
      });
  };

  const InitiateFundTransfer = () => {
    let obj: any = {
      request_id: sessionStorage.getItem("acrequestID"),
      is_fund_transfer_initiated: true,
      amount: amount,
    };
    InitiateFundTransferAccountClosureAPICall(obj)
      .then((response: any) => {
        setshowModal(false);
        window.location.href = "https://app.firstock.in/login";
      })
      .catch((error: any) => {});
  };

  const sendOTPAccoutClosure = () => {
    let obj: any = {
      request_id: sessionStorage.getItem("acrequestID"),
    };
    sendOTPAccoutClosureAPICall(obj)
      .then((response: any) => {
        setshowOTPModal(true);
        setIsButtonDisabled(true);
        setsuccessMessage(response.data.message);
        setTimeout(() => {
          setsuccessMessage("");
        }, 3000);
        setCountdown(30);
        if (timerId === null) {
          let interval = setInterval(() => {
            setCountdown((prevCountdown) => prevCountdown - 1);
          }, 1000);
          setTimerId(interval);
        }
      })
      .catch((error: any) => {
        seterrorMessage(
          error.message.includes("Network")
            ? "Error occured, Please try again"
            : error.response.data.message
        );
        setTimeout(() => {
          seterrorMessage("");
        }, 5000);
      });
  };

  const handleResendOTP = () => {
    let obj: any = {
      request_id: sessionStorage.getItem("acrequestID"),
    };
    ResendOTPAccoutClosureAPICall(obj)
      .then((response: any) => {
        setsuccessMessage(response.data.message);
        setTimeout(() => {
          setsuccessMessage("");
        }, 3000);
        setMobileOtp("");
        setIsButtonDisabled(true);
        setCountdown(30);
        if (timerId === null) {
          let interval = setInterval(() => {
            setCountdown((prevCountdown) => prevCountdown - 1);
          }, 1000);
          setTimerId(interval);
        }
      })
      .catch((error: any) => {
        seterrorMessage(
          error.message.includes("Network")
            ? "Error occured, Please try again"
            : error.response.data.message
        );
        setTimeout(() => {
          seterrorMessage("");
        }, 5000);
      });
  };

  const SubmitSettlement = () => {
    let obj: any = {
      request_id: sessionStorage.getItem("acrequestID"),
      is_fund_transfer_initiated: fundTransfer,
      is_holding_transfer_opted: holdingsType === 2 ? true : false,
      transfer_client_code: clientdpid,
      transfer_dp_id: targetdpid,
      account_type: "both",
      reason: accountClosureReason,
      closure_type: "bo",
      address: address,
    };
    SubmitSettlementAccountClosureAPICall(obj)
      .then((response: any) => {
        console.log("settlementres", response.data.data);
        setNextStage(response.data.data.next_stage);
        sendOTPAccoutClosure();
        // navigate(`/account_closure/${response.data.data.next_stage}`);
      })
      .catch((error) => {
        console.log("error.response", error.response);
        seterrorMessage(error.response.data.message);
        setTimeout(() => {
          seterrorMessage("");
        }, 5000);
      });
  };

  const disabled =
    accountClosureReason === ""
      ? true
      : holdingsType === 2
      ? clientdpid.length < 8 || targetdpid.length < 8
        ? true
        : false
      : false;

  return (
    <>
      <SucessSnackBar message={successMessage} />
      <SnackBar message={errorMessage} />
      <ErrorSnackBar message={rejectMessage} />
      <div className={styles.mainWrapper}>
        <div className={styles.wrapper}>
          <div className={styles.step}>
            <img src={keyboardicon} /> Step 2 of 4
          </div>
          <div className={styles.HeaderSection}>
            <p className={styles.Header}> Account Closure & Settlement</p>
            <p className={styles.subText}>
              Please provide your reason for closing the account and choose how
              to settle your balance.
            </p>
          </div>

          <div className={styles.contentSection}>
            <div className={styles.textFeildSection}>
              <TextField
                className={styles.textfield}
                id="outlined-basic"
                label="Enter Reason For Account Closure"
                placeholder="Enter Minimum 5 characters"
                variant="outlined"
                name="motherFullName"
                value={accountClosureReason}
                onChange={(event: any) => {
                  const value = event.target.value;
                  const validValue = value
                    .replace(/[^A-Za-z\s]/g, "")
                    .replace(/\s{2,}/g, " ");
                  setaccountClosureReason(validValue);
                }}
                inputProps={{
                  sx: {
                    "&::label": {
                      fill: "#111827",
                      fontWeight: 500,
                    },
                    color: "var(--Black-Black-500, #6B7280)",
                    fontSize: "14px",
                  },
                  maxLength: 50,
                  inputMode: "text",
                }}
                sx={{
                  fieldset: {
                    borderColor: "#E5E7EB",
                    borderRadius: "100px",
                    height: "60px",
                  },
                }}
                InputLabelProps={{
                  sx: {
                    color: "#6B7280",
                    fontWeight: 500,
                    "&.MuiFormLabel-filled": {
                      color: "#111827",
                    },
                  },
                }}
              />
            </div>
            <div className={styles.section1title}>Address Details</div>
            <div
              className={styles.textFeildSection}
              style={{ marginTop: "10px" }}
            >
              <TextField
                className={styles.textfield}
                id="outlined-basic"
                // label="Enter your Address"
                placeholder="Enter your Address"
                variant="outlined"
                name="address"
                value={address}
                onChange={(event: any) => {
                  const value = event.target.value;
                  const validValue = value
                    // .replace(/[^A-Za-z\s]/g, "")
                    .replace(/\s{2,}/g, " ");
                  setAddress(validValue);
                }}
                inputProps={{
                  sx: {
                    "&::label": {
                      fill: "#111827",
                      fontWeight: 500,
                    },
                    color: "var(--Black-Black-500, #6B7280)",
                    fontSize: "14px",
                  },
                  maxLength: 250,
                  inputMode: "text",
                }}
                sx={{
                  fieldset: {
                    borderColor: "#E5E7EB",
                    borderRadius: "100px",
                    height: "60px",
                  },
                }}
                InputLabelProps={{
                  sx: {
                    color: "#6B7280",
                    fontWeight: 500,
                    "&.MuiFormLabel-filled": {
                      color: "#111827",
                    },
                  },
                }}
              />
            </div>
            <div className={styles.radioSection}>
              <div className={styles.radioSectionLeft}>
                <div className={styles.title}>Account Closure Type</div>
                <div className={styles.radiogroup}>
                  <div
                    className={styles.radio}
                    style={{ opacity: 0.4, marginLeft: "-10px" }}
                  >
                    <img src={acradio} className={styles.radioicon} /> Trading
                  </div>
                  <div className={styles.radio} style={{ opacity: 0.5 }}>
                    <img src={acradio} className={styles.radioicon} /> Demat
                  </div>
                  <div className={styles.radio}>
                    <img src={acradio} className={styles.radioicon} />{" "}
                    Both(Trading & Demat)
                  </div>
                </div>
              </div>
              <div className={styles.radioSectionLeft}>
                <div className={styles.title}>Closure Initiated By</div>
                <div className={styles.radiogroup}>
                  <div
                    className={styles.radio}
                    style={{ opacity: 0.4, marginLeft: "-10px" }}
                  >
                    <img src={acradio} className={styles.radioicon} /> DP
                  </div>
                  <div className={styles.radio} style={{ opacity: 0.4 }}>
                    <img src={acradio} className={styles.radioicon} /> CDSL
                  </div>
                  <div className={styles.radio}>
                    <img src={acradio} className={styles.radioicon} /> BO
                  </div>
                </div>
              </div>
            </div>

            {/* <div className={styles.fetchedBalanceSection}>
              <div className={styles.label}>Fetched Balance</div>
              <p className={styles.fetchedBalancedesc}>
                Available Balance In Your Account
              </p>
              <p className={styles.fetchedBalanceamount}>₹500.00</p>
            </div> */}

            <div className={styles.infoSection}>
              {amount > 0 && (
                <div
                  className={styles.infoSectionCB}
                  style={{ width: holdings?.length > 0 ? "" : "95%" }}
                >
                  <div
                    className={styles.tsection}
                    style={{
                      flexDirection: holdings?.length > 0 ? "column" : "row",
                      alignItems: holdings?.length > 0 ? "" : "center",
                    }}
                  >
                    <img src={fundTransfer ? payoutsuccessicon : inforedicon} />
                    <p className={styles.tsectiontitle}>
                      {fundTransfer
                        ? "Your Payout Request Initiated"
                        : "Credit Balance Detected in Your Account"}
                    </p>
                  </div>
                  <div className={styles.tsectiondesc}>
                    {fundTransfer
                      ? " We've successfully initiated your payout request. You will be notified once the process is complete."
                      : "You have a positive balance in your wallet. Please initiate a payout to withdraw funds before proceeding to eSign."}
                  </div>

                  <div className={styles.fetchedBalanceSectioncb}>
                    <div className={styles.label}>Fetched Balance</div>
                    <p className={styles.fetchedBalancedesc}>
                      Available Balance In Your Account
                    </p>
                    <p className={styles.fetchedBalanceamount}>₹{amount}</p>
                  </div>
                </div>
              )}
              {holdings?.length > 0 && (
                <div
                  className={styles.infoSectionCB}
                  style={{ width: amount > 0 ? "" : "95%" }}
                >
                  <div
                    className={styles.tsection}
                    style={{
                      flexDirection: amount > 0 ? "column" : "row",
                      alignItems: amount > 0 ? "" : "center",
                    }}
                  >
                    <img src={inforedicon} />
                    <p className={styles.tsectiontitle}>
                      Stock Holdings Detected in Your Account
                    </p>
                  </div>
                  <div className={styles.tsectiondesc}>
                    You have holdings in your account. Please clear your stocks
                    or transfer them to another account before proceeding.To
                    transfer, provide the DP ID and Client ID of the target
                    account.
                  </div>
                </div>
              )}
            </div>

            <div className={styles.selectSection}>
              {/* <div className={styles.section1}>
                <div className={styles.section1title}>
                  Which Would You Like to Settle First?
                </div>
                <div className={styles.options}>
                  <div
                    className={styles.option}
                    onClick={() => {
                      setSettlementType(1);
                    }}
                  >
                    <img
                      src={settlementType === 1 ? acradio : infogreyiconnew}
                    />{" "}
                    Balance Settlement
                  </div>
                  <div
                    className={styles.option}
                    onClick={() => {
                      setSettlementType(2);
                    }}
                  >
                    <img
                      src={settlementType === 2 ? acradio : infogreyiconnew}
                    />{" "}
                    Stock Settlement
                  </div>
                </div>
              </div> */}
              {holdings?.length > 0 && (
                <div className={styles.section1}>
                  <div className={styles.section1title}>
                    What Would You Like to Do With Your Stock Holdings?
                  </div>
                  <div className={styles.options}>
                    <div
                      className={styles.option}
                      onClick={() => {
                        setHoldingsType(1);
                      }}
                    >
                      <img
                        src={holdingsType === 1 ? acradio : infogreyiconnew}
                      />{" "}
                      Sell Holdings
                    </div>
                    <div
                      className={styles.option}
                      onClick={() => {
                        setHoldingsType(2);
                      }}
                    >
                      <img
                        src={holdingsType === 2 ? acradio : infogreyiconnew}
                      />
                      Transfer Holdings
                    </div>
                  </div>
                </div>
              )}
              {holdingsType === 2 && (
                <div className={styles.textfeildWrapper}>
                  <div className={styles.txtfeild}>
                    <TextField
                      autoComplete="off"
                      label="Enter DP ID"
                      id="outlined-size-small"
                      placeholder="Enter 8 digit DP ID"
                      variant="outlined"
                      value={targetdpid}
                      fullWidth
                      inputProps={{
                        sx: {
                          "&::label": {
                            fill: "#111827",
                            fontWeight: 500,
                          },
                          color: "var(--Black-Black-500, #6B7280)",
                          fontSize: "14px",
                        },
                        maxLength: 8,
                        inputMode: "text",
                      }}
                      sx={{
                        fieldset: {
                          borderColor: "#E5E7EB",
                          borderRadius: "100px",
                          height: "60px",
                        },
                      }}
                      InputLabelProps={{
                        sx: {
                          color: "#6B7280",
                          fontWeight: 500,
                          "&.MuiFormLabel-filled": {
                            color: "#111827", // Label color when the field has a value
                          },
                        },
                      }}
                      onKeyPress={(event) => {
                        const keyCode = event.keyCode || event.which;
                        const keyValue = String.fromCharCode(keyCode);
                        const isValidKey = /^\d+$/.test(keyValue);

                        if (!isValidKey) {
                          event.preventDefault();
                        }
                      }}
                      onChange={(event: any) =>
                        settargetdpid(event.target.value.toUpperCase())
                      }
                    />
                  </div>
                  <div className={styles.txtfeild}>
                    <TextField
                      autoComplete="off"
                      label="Enter Client ID"
                      placeholder="Enter 8 digit Client ID"
                      id="outlined-size-small"
                      variant="outlined"
                      value={clientdpid}
                      fullWidth
                      onChange={(event: any) =>
                        setclientdpid(event.target.value.toUpperCase())
                      }
                      inputProps={{
                        sx: {
                          "&::label": {
                            fill: "#111827",
                            fontWeight: 500,
                          },
                          color: "var(--Black-Black-500, #6B7280)",
                          fontSize: "14px",
                        },
                        maxLength: 8,
                        inputMode: "text",
                      }}
                      sx={{
                        fieldset: {
                          borderColor: "#E5E7EB",
                          borderRadius: "100px",
                          height: "60px",
                        },
                      }}
                      InputLabelProps={{
                        sx: {
                          color: "#6B7280",
                          fontWeight: 500,
                          "&.MuiFormLabel-filled": {
                            color: "#111827", // Label color when the field has a value
                          },
                        },
                      }}
                      onKeyPress={(event) => {
                        const keyCode = event.keyCode || event.which;
                        const keyValue = String.fromCharCode(keyCode);
                        const isValidKey = /^\d+$/.test(keyValue);

                        if (!isValidKey) {
                          event.preventDefault();
                        }
                      }}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className={styles.noteSection} style={{ textAlign: "center" }}>
            <span style={{ fontWeight: 600 }}>Note:</span> On clicking Continue,
            an OTP will be sent to {mobileNumber}. Please verify the OTP to
            proceed.
          </div>
          <div
            className={styles.buttonStack}
            style={{ marginTop: holdingsType === 2 ? "" : "0px" }}
          >
            {accountClosureReason === "" || address === "" ? (
              <LoadingButton
                // loading={loading}
                variant="contained"
                type="submit"
                id="linkUsingIFSCContinueButton"
                className={styles.approveButton}
                sx={{
                  height: "50px",
                }}
                disabled
                // onClick={handleSettlement}
              >
                Continue
              </LoadingButton>
            ) : (
              <LoadingButton
                // loading={loading}
                variant="contained"
                type="submit"
                id="linkUsingIFSCContinueButton"
                className={styles.approveButton}
                sx={{
                  height: "50px",
                }}
                disabled={disabled}
                onClick={handleSettlement}
              >
                Continue
              </LoadingButton>
            )}
          </div>
        </div>
      </div>
      {showModal && (
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={showModal}
          closeAfterTransition
          slotProps={{
            backdrop: {
              timeout: 500,
            },
          }}
        >
          <Box sx={successModalStyles}>
            <div className={styles.modalWrapper}>
              <p className={styles.modalWrapperTitle}>
                Hey {userid}, Credit Balance Detected in Your Account
              </p>
              <p className={styles.modalWrapperDesc}>
                You have a positive balance in your wallet. Please initiate a
                payout to withdraw funds before proceeding to eSign.
              </p>

              <div className={styles.fetchedBalanceSectioncb}>
                <div className={styles.label}>Fetched Balance</div>
                <p className={styles.fetchedBalancedesc}>
                  Available Balance In Your Account
                </p>
                <p className={styles.fetchedBalanceamount}>₹{amount}</p>
              </div>

              <div className={styles.buttonSection}>
                <div
                  className={styles.payout}
                  onClick={() => {
                    InitiateFundTransfer();
                  }}
                >
                  Initiate Payout
                </div>
              </div>
            </div>
          </Box>
        </Modal>
      )}
      {showModalPaisa && (
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={showModalPaisa}
          closeAfterTransition
          slotProps={{
            backdrop: {
              timeout: 500,
            },
          }}
        >
          <Box sx={successModalStyles}>
            <div className={styles.modalWrapperPaisa}>
              <p className={styles.modalWrapperTitle}>Balance Refund</p>
              <p className={styles.modalWrapperDesc}>
                ₹{amount} will be automatically refunded to your bank account
                within 2–3 business days after your account closure request is
                processed.
              </p>

              <div className={styles.buttonSection}>
                <div
                  className={styles.payout}
                  onClick={() => {
                    setshowModalPaisa(false);
                  }}
                >
                  Continue
                </div>
              </div>
            </div>
          </Box>
        </Modal>
      )}
      {showOTPModal && (
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={showOTPModal}
          closeAfterTransition
          slotProps={{
            backdrop: {
              timeout: 500,
            },
          }}
        >
          <Box sx={successModalStyles}>
            <div className={styles.modalWrapper}>
              <p className={styles.modalWrapperTitle}>
                Hey {userid}, Verify the otp to continue with the account
                closure.
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setshowOTPModal(false);
                  }}
                >
                  <HighlightOffIcon />
                </div>
              </p>
              {/* <p className={styles.modalWrapperDesc}>
                You have a positive balance in your wallet. Please initiate a
                payout to withdraw funds before proceeding to eSign.
              </p> */}

              <div className={styles.otpSection}>
                <TextField
                  fullWidth
                  placeholder="Enter OTP"
                  type="numeric"
                  className={styles.textfield}
                  variant="outlined"
                  value={mobileotp}
                  onChange={(event) => {
                    const updatedValue = event.target.value;
                    setMobileOtp(updatedValue);
                  }}
                  onKeyPress={(event) => {
                    const keyCode = event.keyCode || event.which;
                    const keyValue = String.fromCharCode(keyCode);
                    const isValidKey = /^\d+$/.test(keyValue);

                    if (!isValidKey) {
                      event.preventDefault();
                    }
                  }}
                  inputProps={{
                    sx: {
                      "&::placeholder": {
                        paddingLeft: "-20px",
                        fill: "var(--Black-Black-500, #6B7280)",
                        fontWeight: 500,
                        // fontSize:"14px",
                        background: "transparent",
                        // height: { xs: "32px", sm: "30px" },
                        letterSpacing: "2px",
                      },
                      // borderLeft: "1px solid #E5E7EB",
                      // height: "30px",
                      paddingLeft: "-20px",
                      fontWeight: 500,
                      letterSpacing: "6px",
                      background: "transparent",
                    },
                    maxLength: 6,
                    inputMode: "numeric",
                    pattern: "[0-9]*",
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment
                        position="start"
                        style={{
                          // borderRight: "1px solid #E5E7EB",
                          // height: "22px",
                          paddingRight: "10px",
                          paddingLeft: "5px",
                        }}
                      >
                        <img src={otpIcon} />
                      </InputAdornment>
                    ),
                  }}
                />
              </div>

              <p className={styles.enterOTPDesc}>
                {isButtonDisabled ? (
                  <span
                    className={styles.resendOTPText}
                    // onClick={handleResendOTP}
                    style={{ color: "grey" }}
                  >
                    Resend OTP in {countdown}s
                  </span>
                ) : (
                  <span
                    className={styles.resendOTPText}
                    onClick={() => {
                      handleResendOTP();
                    }}
                  >
                    Resend OTP
                  </span>
                )}
              </p>

              <div className={styles.buttonSection}>
                <div
                  className={styles.payout}
                  onClick={() => {
                    if (mobileotp?.length >= 5) {
                      SubmitOTP();
                    }
                  }}
                  style={{
                    cursor: mobileotp?.length <= 5 ? "not-allowed" : "pointer",
                  }}
                >
                  Submit
                </div>
              </div>
            </div>
          </Box>
        </Modal>
      )}
    </>
  );
};

export default AccountClosureSettlement;
